export class ExternalAppealDocumentModel {
    constructor(data = {}) {
        this.documentId = data.documentId;
        this.appealId = data.appealId;
        this.type = data.type;
        this.url = data.url;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
    }
}
